import { Component, OnInit } from '@angular/core';
import { PayrollSchedule } from '../../../classes/payroll-schedule';
import { NgForm } from '@angular/forms';
import { PayrollScheduleService } from '../../../services/payroll-schedule.service';
import { INgxMyDpOptions } from 'ngx-mydatepicker';
import { Router, ActivatedRoute } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { UserService } from '../../../../shared/services/user.service';
import { CompanyService } from '../../../services/company.service';

@Component({
  selector: 'app-payroll-schedule-page',
  templateUrl: './payroll-schedule-page.component.html',
  styleUrls: ['./payroll-schedule-page.component.scss']
})
export class PayrollSchedulePageComponent implements OnInit {
  payrollSchedule: any = <any>{};
  payrollSchedules: any[] = [];
  _payrollSchedules: PayrollSchedule[] = [];
  edit: boolean[] = [];
  sub: any;
  orgId: number;
  adding: boolean;
  editing: boolean[] = [];
  isAdmin: boolean;
  error: string;
  company: any;
  steps: any;
  incomplete: boolean;
  state: any;
  focus: any[] = [];
  freqFocus: boolean = false;
  firstFocus: boolean = false;
  startFocus: boolean = false;
  endFocus: boolean = false;
  exFocus: boolean = false;
  openPf: boolean = false;
  openFirst: boolean = false;
  openStart: boolean = false;
  openEnd: boolean = false;
  openExample: boolean = false;
  openPfs: boolean[] = [];
  openFirsts: boolean[] = [];
  openStarts: boolean[] = [];
  openEnds: boolean[] = [];
  openExamples: boolean[] = [];

  public myOptions: INgxMyDpOptions = {
    dateFormat: 'dd/mm/yyyy',
  };

  constructor(
    private PayrollScheduleService: PayrollScheduleService,
    private route: ActivatedRoute,
    private titleService: Title,
    private UserService: UserService,
    private CompanyService: CompanyService,
    private router: Router
  ) { }

  ngOnInit() {
    this.sub = this.route.params.subscribe(params => {
      this.orgId = +params['orgId'];
      let errId: number = +params['errId'];
      if (errId == 1) {
        this.error = 'You cannot go to next step until Business Info, Remittance Info, Banking info and Payroll Schedule are filled.'
      }
      this.getPayroll();
      this.getComplete();
    });
    this.UserService.getUserInfo()
      .subscribe(user => {
        console.log(user)
        let u: any = JSON.parse(user.user);
        this.isAdmin = u.admin;
      }, err => {
        console.log(err)
        if (err.status == 401) {
          localStorage.clear();
          this.router.navigate(['/']);
        }
      })
    this.titleService.setTitle('Payroll Schedule');
  }

  ngOnDestroy() {
    this.sub.unsubscribe();
  }

  getComplete() {
    this.CompanyService.getCompany(this.orgId)
      .subscribe(company => {
        this.company = JSON.parse(company.organization);
        this.steps = JSON.parse(company.steps);
        this.incomplete = this.steps.slice(0, 3).some(s => {
          return !s[2]
        })
        this.state = JSON.parse(company.state);
      }, err => {
        console.log(err)
        if (err.status == 401) {
          localStorage.clear();
          this.router.navigate(['/']);
        }
      })
  }


  getPayroll() {
    this.PayrollScheduleService.getPayrollschedule(this.orgId)
      .subscribe(schedule => {
        this._payrollSchedules = JSON.parse(schedule.payroll_schedules || '[]');
        this.edit = this._payrollSchedules.map(ps => {
          return false;
        })
        this.editing = JSON.parse(JSON.stringify(this.edit));
        this.focus = this._payrollSchedules.map(ps => {
          return {
            freqFocus: false,
            firstFocus: false,
            startFocus: false,
            endFocus: false,
            exFocus: false
          };
        })
        this.payrollSchedules = this._payrollSchedules.map(p => {
          let fd = new Date(p.first_pay_date_of_the_year);
          let start = new Date(p.most_recent_pay_period_start);
          let end = new Date(p.most_recent_pay_period_end);
          let pd = new Date(p.most_recent_pay_date);
          return {
            pay_frequency: p.pay_frequency,
            first_pay_date_of_the_year: {
              date: {
                year: fd.getFullYear(), month: fd.getMonth() + 1, day: fd.getDate()
              }
            },
            most_recent_pay_period_start: {
              date: {
                year: start.getFullYear(), month: start.getMonth() + 1, day: start.getDate()
              }
            },
            most_recent_pay_period_end: {
              date: {
                year: end.getFullYear(), month: end.getMonth() + 1, day: end.getDate()
              }
            },
            most_recent_pay_date: {
              date: {
                year: pd.getFullYear(), month: pd.getMonth() + 1, day: pd.getDate()
              }
            },
            id: p.id
          }
        })

        this.openPfs = this._payrollSchedules.map(p => {
          return false;
        });

        this.openFirsts = this._payrollSchedules.map(p => {
          return false;
        });

        this.openStarts = this._payrollSchedules.map(p => {
          return false;
        });

        this.openEnds = this._payrollSchedules.map(p => {
          return false;
        });

        this.openExamples = this._payrollSchedules.map(p => {
          return false;
        });

      }, err => {
        console.log(err)
        if (err.status == 401) {
          localStorage.clear();
          this.router.navigate(['/']);
        }
      })
  }

  convertDate(d: any) {
    return new Date(d.date.year, d.date.month - 1, d.date.day);
  }

  addPayroll(payScheduleForm: NgForm) {
    this.adding = true;
    if (payScheduleForm.invalid) {
      return;
    }
    this.payrollSchedule.first_pay_date_of_the_year = new Date(this.payrollSchedule.first_pay_date_of_the_year.date.year,
      this.payrollSchedule.first_pay_date_of_the_year.date.month - 1,
      this.payrollSchedule.first_pay_date_of_the_year.date.day + 1);

    this.payrollSchedule.most_recent_pay_period_start = new Date(this.payrollSchedule.most_recent_pay_period_start.date.year,
      this.payrollSchedule.most_recent_pay_period_start.date.month - 1,
      this.payrollSchedule.most_recent_pay_period_start.date.day + 1);

    this.payrollSchedule.most_recent_pay_period_end = new Date(this.payrollSchedule.most_recent_pay_period_end.date.year,
      this.payrollSchedule.most_recent_pay_period_end.date.month - 1,
      this.payrollSchedule.most_recent_pay_period_end.date.day + 1);

    this.payrollSchedule.most_recent_pay_date = new Date(this.payrollSchedule.most_recent_pay_date.date.year,
      this.payrollSchedule.most_recent_pay_date.date.month - 1,
      this.payrollSchedule.most_recent_pay_date.date.day + 1);

    this.PayrollScheduleService.addPayrollSchedule(this.orgId, this.payrollSchedule)
      .subscribe(schedule => {
        this.adding = false;
        if(!this.isAdmin) window.analytics.track("Self-Signup Payroll Schedule Added", {OrgId: this.orgId});
        this.getPayroll();
        payScheduleForm.reset();
        this.payrollSchedule = <PayrollSchedule>{};
        this.getComplete();
      }, err => {
        console.log(err)
        if (err.status == 401) {
          localStorage.clear();
          this.router.navigate(['/']);
        } else {
          if(!this.isAdmin) window.analytics.track("Self-Signup Payroll Schedule Addition Failed", {OrgId: this.orgId, reason: err._body});
        }
      })
  }

  editPayroll(index: number) {
    this.edit[index] = true;
  }

  deletePayroll(id: number) {
    this.PayrollScheduleService.deletePayrollSchedule(this.orgId, id)
      .subscribe(schedule => {
        this.getPayroll();
        this.getComplete();
      }, err => {
        console.log(err)
        if (err.status == 401) {
          localStorage.clear();
          this.router.navigate(['/']);
        }
      })
  }

  completeEdit(id: number, payScheduleForm: NgForm, payrollSchedule: any, index: number) {
    this.editing[index] = true;
    if (payScheduleForm.invalid) {
      return;
    }

    payrollSchedule.first_pay_date_of_the_year = new Date(payrollSchedule.first_pay_date_of_the_year.date.year,
      payrollSchedule.first_pay_date_of_the_year.date.month - 1,
      payrollSchedule.first_pay_date_of_the_year.date.day + 1);

    payrollSchedule.most_recent_pay_period_start = new Date(payrollSchedule.most_recent_pay_period_start.date.year,
      payrollSchedule.most_recent_pay_period_start.date.month - 1,
      payrollSchedule.most_recent_pay_period_start.date.day + 1);

    payrollSchedule.most_recent_pay_period_end = new Date(payrollSchedule.most_recent_pay_period_end.date.year,
      payrollSchedule.most_recent_pay_period_end.date.month - 1,
      payrollSchedule.most_recent_pay_period_end.date.day + 1);

    payrollSchedule.most_recent_pay_date = new Date(payrollSchedule.most_recent_pay_date.date.year,
      payrollSchedule.most_recent_pay_date.date.month - 1,
      payrollSchedule.most_recent_pay_date.date.day + 1);

    this.PayrollScheduleService.editPayrollSchedule(this.orgId, id, payrollSchedule)
      .subscribe(schedule => {
        this.editing[index] = true;
        this.getPayroll();
      }, err => {
        console.log(err)
        if (err.status == 401) {
          localStorage.clear();
          this.router.navigate(['/']);
        }
      })
  }

  showError(ev: string) {
    this.error = ev;
  }

  onClickedOutside(e: any) {
    console.log('Clicked outside:', e);
    if (e.target.className != 'fa fa-question-circle-o') {
      this.openPf = false;
      this.openStart = false;
      this.openEnd = false;
      this.openExample = false;
      this.openFirst = false;
      this.openPfs = this.payrollSchedules.map(r => { return false });
      this.openStarts = this.payrollSchedules.map(r => { return false });
      this.openEnds = this.payrollSchedules.map(r => { return false });
      this.openExamples = this.payrollSchedules.map(r => { return false });
      this.openFirsts = this.payrollSchedules.map(r => { return false });
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/onboarding/components/company-setup/payroll-schedule-page/payroll-schedule-page.component.ts